import requestor from "../../requestor";

export default class VerificationApi {
  all = (page, status = "") =>
    requestor.get("/manage/verify_request-all", {
      page,
      filter: { status: status },
    });
  one = (id) => requestor.get("/manage/verify_request-one", { id: id });
  changeState = (id, stateId, reason) => requestor.post("/manage/verify_request-change-state", { id: id, state_id: stateId, reason: reason});
}
